module.exports = {
    Page: "Page",
    PageConfig: "PageConfig",
    TranslationJob: "TranslationJob",
    CurrentPageVersion: "CurrentPageVersion"
};
